import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import StarIcon from "@mui/icons-material/StarBorder";
import CardHeader from "@mui/material/CardHeader";
import { Link } from "react-router-dom";
import {
  ThemeProvider,
  StyledEngineProvider,
  styled,
} from "@mui/material/styles";
import MoreInfo from "./MaterialComponents/MoreInfo";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import { theme } from "./MaterialStyling";
const PREFIX = "SplashPage";

const classes = {
  heroContent: `${PREFIX}-heroContent`,
  heroButtons: `${PREFIX}-heroButtons`,
  cardGrid: `${PREFIX}-cardGrid`,
  card: `${PREFIX}-card`,
  root: `${PREFIX}-root`,
  cardHeader: `${PREFIX}-cardHeader`,
  mainContent: `${PREFIX}-mainContent`,
  cardPricing: `${PREFIX}-cardPricing`,
  reducedPadding: `${PREFIX}-reducedPadding`,
  OrMargin: `${PREFIX}-OrMargin`,
  facebookIcon: `${PREFIX}-facebookIcon`,
  linkedInIcon: `${PREFIX}-linkedInIcon`,
  twitterIcon: `${PREFIX}-twitterIcon`,
  youTubeIcon: `${PREFIX}-youTubeIcon`,
  overallPaper: `${PREFIX}-overallPaper`,
};

const StyledThemeProvider = styled("div")({
  [`& .${classes.heroContent}`]: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(5, 0, 0),
  },

  [`& .${classes.heroButtons}`]: {
    marginTop: theme.spacing(0),
  },

  [`& .${classes.cardGrid}`]: {
    paddingBottom: theme.spacing(8),
  },

  [`& .${classes.card}`]: {
    display: "flex",
    alignItems: "flex-end",
  },

  [`& .${classes.root}`]: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  [`& .${classes.cardHeader}`]: {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[700],
  },

  [`& .${classes.mainContent}`]: {
    height: "100%",
    padding: theme.spacing(0),
  },

  [`& .${classes.cardPricing}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },

  [`& .${classes.reducedPadding}`]: {
    padding: "2px 0px",
  },

  [`& .${classes.OrMargin}`]: {
    margin: theme.spacing(3, 0, 4, 0),
  },

  [`& .${classes.facebookIcon}`]: {
    color: "#3B5998",
  },

  [`& .${classes.linkedInIcon}`]: {
    color: "#0e76a8",
  },

  [`& .${classes.twitterIcon}`]: {
    color: "#1DA1F2",
  },

  [`& .${classes.youTubeIcon}`]: {
    color: "#FF0000",
  },

  [`& .${classes.overallPaper}`]: {
    padding: 16,
    borderRadius: 16,
  },
});
// const StyledThemeProvider = styled(ThemeProvider)(({ theme }) => ({}));

export default function SplashPage() {
  const isSuperUser = localStorage.getItem("superUser") === "true";
  const [products, setProducts] = useState([
    {
      title: "Social Media",
      subheader: "Identify which of your ads works best on social platforms",
      price: "0",
      description1: ["Video", "Static"],
      description2: ["Newsfeed", "Stories", "Watch feed"],
      buttonText: "Get started",
      buttonVariant: "outlined",
      moreInfo:
      "Test your ad on a Facebook environment (Instagram, Twitter, LinkedIn and Snapchat coming soon)",
    link: "/create-study/social-media-study",
    },
    {
      title: "Out Of Home",
      subheader: "Identify which of your ads works best in an out of home video. ",
      price: "0",
      description1: ["Video"],
     
      buttonText: "Get started",
      buttonVariant: "outlined",
      moreInfo:
      "Test your ad on a Video environment (Out Of Home, TV and Gaming)",
    link: "/create-study/OOH-study",
    },
    {
      title: "Gaming",
      subheader: "Identify which of your ads works best in a gaming video. ",
      price: "0",
      description1: ["Video"],
      
      buttonText: "Get started",
      buttonVariant: "outlined",
      moreInfo:
      "Test your ad on a Video environment (Out Of Home, TV and Gaming)",
    link:"/create-study/Gaming-study",
    },
    {
      title: "Digital Ad Test",
      subheader:
        "Identify which of your ads works best as a standard digital format",
      price: "0",
      description1: ["Video", "Static"],
      description2: ["MPU/DMPU", "Skyscraper", "Billboard", "LeaderBoard"],
      buttonText: "Get Started",
      buttonVariant: "outlined",
      link: "/create-study/digital-ad-test",
      moreInfo: "Test your video or static display ad on a live webpage",
    },
    {
      title: "YouTube",
      subheader: "Identify your strongest YouTube creative",
      price: "0",
      description1: ["Video"],
      description2: ['6" bumper', '15" or 20" skippable', "Non-skippable"],
      buttonText: "Get started",
      buttonVariant: "outlined",
      moreInfo: "Test your video ad on a YouTube environment",
      link: "/create-study/YouTube-study",
    },
    {
      title: "Vast Ad Test",
      subheader: "Identify which of your ads works best as a vast video format",
      price: "0",
      description1: ["VAST", "Video"],
      description2: ["Bespoke web pages"],
      buttonText: "Get started",
      buttonVariant: "outlined",
      moreInfo: "Test your VAST script on a live web page",
      link: "/create-study/vast-ad-test",
    },
  ]);

  useEffect(() => {
    if (!isSuperUser) return;

    const superUserProducts = [
      {
        title: "Digital Rich Media",
        subheader:
          "Test your rich media creative to understand its performance",
        price: "0",
        description1: ["Video", "Static", "Interactive"],
        description2: ["Skins", "Page Takeovers", "Outstream video"],
        buttonText: "Get started",
        buttonVariant: "outlined",
        link: "/create-study/digital-rich-study",
        moreInfo:
          "Test your rich media ad (e.g. page skins) or outstream video format ad on a live webpage",
      },
      {
        title: "Focus Project Setup",
        subheader: "Assign the panelists for a Lumen study",
        price: "0",
        description1: ["Mobile", "Desktop", ""],
        buttonText: "Get started",
        buttonVariant: "outlined",
        link: "/create-study/Lumen-panel-setup",
        moreInfo: "Create a task for the Lumen Panel",
      },
    ];

    setProducts((products) => products.concat(superUserProducts));
  }, [isSuperUser]);

  const customOrder = [
  "Digital Ad Test",
  "Social Media",
  "YouTube",
  "Vast Ad Test",
  "Digital Rich Media",
  "Focus Project Setup",
  "Out Of Home",
  "Gaming",
];

const orderedProducts = [];

for (const title of customOrder) {
  const matchingProduct = products.find(product => product.title === title);
  
  if (matchingProduct) {
    orderedProducts.push(matchingProduct);
  }
}

const renderCard = (product) => (
  <Card variant="outlined" className={classes.root}>
    <MoreInfo
      outerContainerClassName=""
      middleContainerClassName="relativeContainer"
      innerContainerClassName="createStudy"
      leftRight="right"
      popup={product.moreInfo}
    />
    <CardHeader
      title={product.title}
      subheader={product.subheader}
      titleTypographyProps={{ align: "center" }}
      subheaderTypographyProps={{ align: "center" }}
      action={product.title === "Pro" ? <StarIcon /> : null}
      className={classes.cardHeader}
    />
    <CardContent className={classes.mainContent}>
      <ul>
        {product.description1.map((line, i) => (
          <Typography
            component="li"
            variant="subtitle1"
            align="center"
            key={i}
            className={classes.reducedPadding}
          >
            {line}
          </Typography>
        ))}
      </ul>
      {product.description2 && (
        <>
          <Divider variant="middle" />
          <ul>
            {product.description2.map((line, i) => (
              <Typography
                component="li"
                variant="subtitle1"
                align="center"
                key={i}
                className={classes.reducedPadding}
              >
                {line}
              </Typography>
            ))}
          </ul>
        </>
      )}
    </CardContent>
    <CardActions>
      <Button
        component={Link}
        to={product.link}
        fullWidth
        variant={product.buttonVariant}
        color="primary"
      >
        {product.buttonText}
      </Button>
    </CardActions>
  </Card>
);

  return (
    <StyledThemeProvider className={classes.root}>
      <ThemeProvider theme={theme}>
        <Paper className={classes.overallPaper}>
          <StyledEngineProvider injectFirst>
            <div className={classes.heroContent}>
              <Container maxWidth="sm">
                <Typography
                  variant="h2"
                  align="center"
                  color="primary"
                  gutterBottom
                 
                >
                  Choose your study
                </Typography>
                <Typography
                  variant="subtitle1"
                  align="center"
                  color="textSecondary"
                  paragraph
                 
                >
                  You can now take advantage of amongst the most advanced eye
                  tracking technology on the market. Let&apos;s begin by
                  choosing the research method that is right for you.
                </Typography>

                <div className={classes.heroButtons}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item>
                      <MoreInfo
                        outerContainerClassName=""
                        middleContainerClassName="createCustomStudy"
                        innerContainerClassName=""
                        leftRight="right"
                        popup="Use our cell step creator tool to design your own fully customizable studies."
                      />
                    <Button
  component={Link}
  to="/create-study/custom-study"
  className="button-primary"
>
  Create custom study
</Button>
                    </Grid>
                  </Grid>
                </div>
              </Container>
            </div>

            <Container className={classes.cardGrid} maxWidth="lg">
              <Grid className={classes.OrMargin}>
                <Typography
                  variant="subtitle1"
                  align="center"
                  color="textSecondary"
                  paragraph
                 
                >
                  OR
                </Typography>
              </Grid>
{/* Row 1*/}
<Box mt={4} mb={4}>
  <Grid container justifyContent="center" spacing={4}>
    {orderedProducts
      .filter(p => p.title === "Digital Ad Test")
      .map((product, index) => (
        <Grid className={classes.card} item key={index} xs={12} sm={6} md={4} lg={3}>
          {renderCard(product)}
        </Grid>
      ))}
  </Grid>
</Box>

{/* Row 2*/}
<Box mt={4} mb={4}>
  <Grid container justifyContent="center" spacing={4}>
    {orderedProducts
      .filter(p =>
        ["Social Media", "YouTube", "Vast Ad Test", "Digital Rich Media"].includes(p.title)
      )
      .map((product, index) => (
        <Grid className={classes.card} item key={index} xs={12} sm={6} md={4} lg={3}>
          {renderCard(product)}
        </Grid>
      ))}
  </Grid>
</Box>

{/* Row 3*/}
<Box mt={4} mb={6}>
  <Grid container justifyContent="center" spacing={4}>
    {orderedProducts
      .filter(p =>
        ["Focus Project Setup", "Out Of Home", "Gaming"].includes(p.title)
      )
      .map((product, index) => (
        <Grid className={classes.card} item key={index} xs={12} sm={6} md={4} lg={3}>
          {renderCard(product)}
        </Grid>
      ))}
  </Grid>
</Box>


            </Container>
          </StyledEngineProvider>
        </Paper>
      </ThemeProvider>
    </StyledThemeProvider>
  );
}
